/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseRegionGeoModalFragment, RegionGeoModalFragment, FullRegionGeoModalFragment} from '@amblique/contentful/app/contentful/fragments/region-geo-modal';

/**
 * Get a single RegionGeoModal by ID (base - scalars only)
 */
export const getBaseRegionGeoModalById = gql`
  ${BaseRegionGeoModalFragment}

  query GetBaseRegionGeoModalById($id: String!, $locale: String!, $preview: Boolean) {
    regionGeoModal(id: $id, locale: $locale, preview: $preview) {
      ...BaseRegionGeoModalFragment
    }
  }
`;

/**
 * Get a single RegionGeoModal by ID (standard - 1 level deep)
 */
export const getRegionGeoModalById = gql`
  ${RegionGeoModalFragment}

  query GetRegionGeoModalById($id: String!, $locale: String!, $preview: Boolean) {
    regionGeoModal(id: $id, locale: $locale, preview: $preview) {
      ...RegionGeoModalFragment
    }
  }
`;

/**
 * Get a single RegionGeoModal by ID (full - 2 levels deep)
 */
export const getFullRegionGeoModalById = gql`
  ${FullRegionGeoModalFragment}

  query GetFullRegionGeoModalById($id: String!, $locale: String!, $preview: Boolean) {
    regionGeoModal(id: $id, locale: $locale, preview: $preview) {
      ...FullRegionGeoModalFragment
    }
  }
`;

/**
 * Get all RegionGeoModal entries with pagination (base - scalars only)
 */
export const getBaseRegionGeoModals = gql`
  ${BaseRegionGeoModalFragment}

  query GetBaseRegionGeoModals(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [RegionGeoModalOrder]
    $where: RegionGeoModalFilter
    $preview: Boolean
  ) {
    regionGeoModalCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...BaseRegionGeoModalFragment
      }
    }
  }
`;

/**
 * Get all RegionGeoModal entries with pagination (standard - 1 level deep)
 */
export const getRegionGeoModals = gql`
  ${RegionGeoModalFragment}

  query GetRegionGeoModals(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [RegionGeoModalOrder]
    $where: RegionGeoModalFilter
    $preview: Boolean
  ) {
    regionGeoModalCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...RegionGeoModalFragment
      }
    }
  }
`;

/**
 * Get all RegionGeoModal entries with pagination (full - 2 levels deep)
 */
export const getFullRegionGeoModals = gql`
  ${FullRegionGeoModalFragment}

  query GetFullRegionGeoModals(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [RegionGeoModalOrder]
    $where: RegionGeoModalFilter
    $preview: Boolean
  ) {
    regionGeoModalCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...FullRegionGeoModalFragment
      }
    }
  }
`;
